import Injection = EECore.Injection;
import Service from "../../services/instabilityMessages/instabilityMessagesService";
import Model from "../models/instabilityMessages/instabilityMessageModel";
import { WidgetResources } from "../../resources/widget";

export const SITECORE_MEDIA_PREFIX = "-/media/";
export const SITECORE_EXTRANET_PREFIX = "/cw/";

@Injection.injectableClass("EEWidget.InstabilityMessages")
export default class InstabilityMessages implements EECore.UI.IWebComponent {

  @Injection.injectableProperty("EEWidget.InstabilityMessages", "WidgetResources")
  private resources: WidgetResources;

  @Injection.injectableProperty("EEWidget.InstabilityMessages", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("EEWidget.InstabilityMessages", EECore.Registrations.DOCUMENT)
  private document: Document;

  @Injection.injectableProperty("EEWidget.InstabilityMessages", "InstabilityMessagesService")
  private service: Service;

  @Injection.injectableProperty("EEWidget.InstabilityMessages", EECore.Registrations.AUTH_SERVICE)
  private authService: EECore.Services.AuthService;

  @Injection.injectableProperty("EEWidget.InstabilityMessages", EECore.Registrations.INTEGRATION_CONTEXT)
  private integrationContext: EECore.Integration.Context;

  constructor(templateFactory: EECore.UI.TemplateFactory,
    document: Document,
    service: Service,
    resources: WidgetResources,
    authService: EECore.Services.AuthService,
    integrationContext: EECore.Integration.Context) {
    this.templateFactory = templateFactory;
    this.document = document;
    this.service = service;
    this.resources = resources;
    this.authService = authService;
    this.integrationContext = integrationContext;
  }

  load(container: Element): EECore.Promise<Element, string> {
    const applicationName = container.getAttribute("ee-application-name") || "";

    return new EECore.Promise<Element, string>((resolve) => {
      this.service.getInstabilityMessages(applicationName).then((messages: string[]) => {
        resolve(this.renderTemplate(messages));
      }).catch(() => {
        resolve(this.renderTemplate(this.getMessage()));
      });
    });
  }

  protected renderTemplate(messages: string[]): Element {
    if (!messages || messages.length === 0) {
      return this.document.createDocumentFragment() as any;
    } else if (messages.length === 1) {
      const model = this.stringToModel(messages[0]);
      const component = this.templateFactory.getTemplate("InstabilityMessagesSingle", model);
      this.rewriteMediaUrl(component);
      return component;
    }

    const template = this.templateFactory.getTemplate("InstabilityMessagesMultiple", null);
    const messagesContainer = template.querySelector(".instabilityMessages_content");
    this.renderItems(messagesContainer, messages);

    return template;
  }

  protected renderItems(messagesContainer: Element, messages: string[]): void {
    for (let i = 0; i < messages.length; i++) {
      const model = this.stringToModel(messages[i]);
      const component = this.templateFactory.getTemplate("InstabilityMessagesMultipleItem", model);
      this.rewriteMediaUrl(component);
      messagesContainer.appendChild(component);
    }
  }

  private stringToModel(message: string): Model {
    const model = new Model();
    model.message = message;
    return model;
  }

  private getMessage(): string[] {
    const clientSiteWithoutMessage: string[] = ["IAVM", "INVESTIA", "FUNDEX"];
    const messages = new Array<string>();

    if (this.integrationContext.experience.audience === EECore.Integration.Audience.Client) {
      if (clientSiteWithoutMessage.indexOf(this.integrationContext.experience.company) > -1)
        return messages;
    }

    if (this.authService.isAuthenticated()) {
      if (this.integrationContext.experience.audience === EECore.Integration.Audience.Advisor) {
        switch (this.integrationContext.experience.company) {
          case "IA": {
            messages.push(this.resources.instabilityMessage.iaAdvisorMessage);
            return messages;
          }
          case "INVESTIA": {
            messages.push(this.resources.instabilityMessage.investiaAdvisorMessage);
            return messages;
          }
          case "FUNDEX": {
            messages.push(this.resources.instabilityMessage.fundexAdvisorMessage);
            return messages;
          }
          default: {
            break;
          }
        }
      }

      if (this.integrationContext.experience.audience === EECore.Integration.Audience.Employee && this.integrationContext.experience.company === "IA") {
        messages.push(this.resources.instabilityMessage.iaAdvisorMessage);
        return messages;
      }

      messages.push(this.resources.instabilityMessage.baseMessage);
      return messages;
    }
    else {
      if (this.integrationContext.experience.audience === EECore.Integration.Audience.Advisor && this.integrationContext.experience.company === "IA") {
        messages.push(this.resources.instabilityMessage.iaAdvisorMessage);
        return messages;
      }

      return messages;
    }
  }

  private rewriteMediaUrl(component: Element) {
    const images = component.querySelectorAll("img");
    for (let i = 0; i < images.length; i++) {
      const src = images[i].getAttribute("src");
      images[i].setAttribute("src", src.replace(SITECORE_MEDIA_PREFIX, SITECORE_EXTRANET_PREFIX + SITECORE_MEDIA_PREFIX));
    }
  }
}